export default __webpack_public_path__ + "static/media/star-flyer.4db2a5f2.webp";